import { useEffect, useState } from 'react';
import { masterDataApi, type MasterOption } from '@/api/masterData.api';

let cache: {
  countries: MasterOption[];
  currencies: MasterOption[];
  timezones: MasterOption[];
  taxModes: MasterOption[];
} | null = null;

/** Stable fallbacks — avoid new [] each render (breaks useEffect deps). */
const EMPTY_OPTIONS: MasterOption[] = [];

export function useMasterData() {
  const [data, setData] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) {
      setData(cache);
      return;
    }
    masterDataApi
      .all()
      .then((res) => {
        cache = res;
        setData(res);
      })
      .finally(() => setLoading(false));
  }, []);

  return {
    loading,
    countries: data?.countries ?? EMPTY_OPTIONS,
    currencies: data?.currencies ?? EMPTY_OPTIONS,
    timezones: data?.timezones ?? EMPTY_OPTIONS,
    taxModes: data?.taxModes ?? EMPTY_OPTIONS,
  };
}
